import { TFunction } from 'i18next';
import { ResultField } from '../ResultField';

interface RegistrationLicense {
  registrationNumber: string | null;
  firstRegistrationDate: string | null;
  registeredOwnerName: string | null;
  ownerStatus: string | null;
  coOwner: string | null;
  address: string | null;
  make: string | null;
  type: string | null;
  nationalTypeCode: string | null;
  model: string | null;
  vinNumber: string | null;
  grossVehicleWeightInKg: string | null;
  grossTrainWeightInKg: string | null;
  maxCombinationWeightInKg: string | null;
  massInRunningOrderInKg: string | null;
  unladenWeightInKg: string | null;
  euCategory: string | null;
  nationalBodyType: string | null;
  euBodyType: string | null;
  nationalBodyDesignation: string | null;
  typeApprovalNumber: string | null;
  engineDisplacementInCc: string | null;
  netPowerInKW: string | null;
  fuelType: string | null;
  fiscalHorsepowerInHP: string | null;
  soundLevelInDBa: string | null;
  engineSpeedInRpm: string | null;
  co2EmissionsInGPerKm: string | null;
  euroEmissionClass: string | null;
  vehicleInspectionDate: string | null;
  regionalTaxInEuro: string | null;
  vocationalTrainingTaxInEuro: string | null;
  co2EcoTaxInEuro: string | null;
  adminManagementTaxInEuro: string | null;
  routingFeeInEuro: string | null;
  totalRegistrationCertificatePriceInEuro: string | null;
  issueDate: string | null;
  issuingAuthority: string | null;
}

interface RegistrationLicenseInfosProps {
  t?: TFunction<undefined>;
  item: RegistrationLicense;
}

export const RegistrationLicenseInfos = ({
  t,
  item,
}: RegistrationLicenseInfosProps) => {
  return (
    <>
      {item?.registrationNumber && (
        <ResultField text={`${t('common:licensePlateNumber')} :`}>
          <p className="font-semibold">{item?.registrationNumber?.trim()}</p>
        </ResultField>
      )}
      {item?.firstRegistrationDate && (
        <ResultField text={`${t('common:yearOfFirstRegistration')} :`}>
          <p className="font-semibold">{item?.firstRegistrationDate?.trim()}</p>
        </ResultField>
      )}
      {item?.registeredOwnerName && (
        <ResultField text={`${t('registeredOwnerName')} :`}>
          <p className="font-semibold">{item?.registeredOwnerName?.trim()}</p>
        </ResultField>
      )}
      {item?.ownerStatus && (
        <ResultField text={`${t('ownerStatus')} :`}>
          <p className="font-semibold">{item?.ownerStatus?.trim()}</p>
        </ResultField>
      )}
      {item?.coOwner && (
        <ResultField text={`${t('coOwner')} :`}>
          <p className="font-semibold">{item?.coOwner?.trim()}</p>
        </ResultField>
      )}
      {item?.address && (
        <ResultField text={`${t('common:address')} :`}>
          <p className="font-semibold">{item?.address?.trim()}</p>
        </ResultField>
      )}
      {item?.make && (
        <ResultField text={`${t('common:brand')} :`}>
          <p className="font-semibold">{item?.make?.trim()}</p>
        </ResultField>
      )}
      {item?.type && (
        <ResultField text={`${t('common:type')} :`}>
          <p className="font-semibold">{item?.type?.trim()}</p>
        </ResultField>
      )}
      {item?.nationalTypeCode && (
        <ResultField text={`${t('nationalTypeCode')} :`}>
          <p className="font-semibold">{item?.nationalTypeCode?.trim()}</p>
        </ResultField>
      )}
      {item?.model && (
        <ResultField text={`${t('common:model')} :`}>
          <p className="font-semibold">{item?.model?.trim()}</p>
        </ResultField>
      )}
      {item?.vinNumber && (
        <ResultField text={`${t('common:vin')} :`}>
          <p className="font-semibold">{item?.vinNumber?.trim()}</p>
        </ResultField>
      )}
      {item?.grossVehicleWeightInKg && (
        <ResultField text={`${t('grossVehicleWeightInKg')} :`}>
          <p className="font-semibold">
            {item?.grossVehicleWeightInKg?.trim()}
          </p>
        </ResultField>
      )}
      {item?.grossTrainWeightInKg && (
        <ResultField text={`${t('grossTrainWeightInKg')} :`}>
          <p className="font-semibold">{item?.grossTrainWeightInKg?.trim()}</p>
        </ResultField>
      )}
      {item?.maxCombinationWeightInKg && (
        <ResultField text={`${t('maxCombinationWeightInKg')} :`}>
          <p className="font-semibold">
            {item?.maxCombinationWeightInKg?.trim()}
          </p>
        </ResultField>
      )}
      {item?.massInRunningOrderInKg && (
        <ResultField text={`${t('massInRunningOrderInKg')} :`}>
          <p className="font-semibold">
            {item?.massInRunningOrderInKg?.trim()}
          </p>
        </ResultField>
      )}
      {item?.unladenWeightInKg && (
        <ResultField text={`${t('unladenWeightInKg')} :`}>
          <p className="font-semibold">{item?.unladenWeightInKg?.trim()}</p>
        </ResultField>
      )}
      {item?.euCategory && (
        <ResultField text={`${t('euCategory')} :`}>
          <p className="font-semibold">{item?.euCategory?.trim()}</p>
        </ResultField>
      )}
      {item?.nationalBodyType && (
        <ResultField text={`${t('nationalBodyType')} :`}>
          <p className="font-semibold">{item?.nationalBodyType?.trim()}</p>
        </ResultField>
      )}
      {item?.euBodyType && (
        <ResultField text={`${t('euBodyType')} :`}>
          <p className="font-semibold">{item?.euBodyType?.trim()}</p>
        </ResultField>
      )}
      {item?.nationalBodyDesignation && (
        <ResultField text={`${t('nationalBodyDesignation')} :`}>
          <p className="font-semibold">
            {item?.nationalBodyDesignation?.trim()}
          </p>
        </ResultField>
      )}
      {item?.typeApprovalNumber && (
        <ResultField text={`${t('typeApprovalNumber')} :`}>
          <p className="font-semibold">{item?.typeApprovalNumber?.trim()}</p>
        </ResultField>
      )}
      {item?.engineDisplacementInCc && (
        <ResultField text={`${t('engineDisplacementInCc')} :`}>
          <p className="font-semibold">
            {item?.engineDisplacementInCc?.trim()}
          </p>
        </ResultField>
      )}
      {item?.netPowerInKW && (
        <ResultField text={`${t('netPowerInKW')} :`}>
          <p className="font-semibold">{item?.netPowerInKW?.trim()}</p>
        </ResultField>
      )}
      {item?.fuelType && (
        <ResultField text={`${t('fuelType')} :`}>
          <p className="font-semibold">{item?.fuelType?.trim()}</p>
        </ResultField>
      )}
      {item?.fiscalHorsepowerInHP && (
        <ResultField text={`${t('fiscalHorsepowerInHP')} :`}>
          <p className="font-semibold">{item?.fiscalHorsepowerInHP?.trim()}</p>
        </ResultField>
      )}
      {item?.soundLevelInDBa && (
        <ResultField text={`${t('soundLevelInDBa')} :`}>
          <p className="font-semibold">{item?.soundLevelInDBa?.trim()}</p>
        </ResultField>
      )}
      {item?.engineSpeedInRpm && (
        <ResultField text={`${t('engineSpeedInRpm')} :`}>
          <p className="font-semibold">{item?.engineSpeedInRpm?.trim()}</p>
        </ResultField>
      )}
      {item?.co2EmissionsInGPerKm && (
        <ResultField text={`${t('co2EmissionsInGPerKm')} :`}>
          <p className="font-semibold">{item?.co2EmissionsInGPerKm?.trim()}</p>
        </ResultField>
      )}
      {item?.euroEmissionClass && (
        <ResultField text={`${t('euroEmissionClass')} :`}>
          <p className="font-semibold">{item?.euroEmissionClass?.trim()}</p>
        </ResultField>
      )}
      {item?.vehicleInspectionDate && (
        <ResultField text={`${t('vehicleInspectionDate')} :`}>
          <p className="font-semibold">{item?.vehicleInspectionDate?.trim()}</p>
        </ResultField>
      )}
      {item?.regionalTaxInEuro && (
        <ResultField text={`${t('regionalTaxInEuro')} :`}>
          <p className="font-semibold">{item?.regionalTaxInEuro?.trim()}</p>
        </ResultField>
      )}
      {item?.vocationalTrainingTaxInEuro && (
        <ResultField text={`${t('vocationalTrainingTaxInEuro')} :`}>
          <p className="font-semibold">
            {item?.vocationalTrainingTaxInEuro?.trim()}
          </p>
        </ResultField>
      )}
      {item?.co2EcoTaxInEuro && (
        <ResultField text={`${t('co2EcoTaxInEuro')} :`}>
          <p className="font-semibold">{item?.co2EcoTaxInEuro?.trim()}</p>
        </ResultField>
      )}
      {item?.adminManagementTaxInEuro && (
        <ResultField text={`${t('adminManagementTaxInEuro')} :`}>
          <p className="font-semibold">
            {item?.adminManagementTaxInEuro?.trim()}
          </p>
        </ResultField>
      )}
      {item?.routingFeeInEuro && (
        <ResultField text={`${t('routingFeeInEuro')} :`}>
          <p className="font-semibold">{item?.routingFeeInEuro?.trim()}</p>
        </ResultField>
      )}
      {item?.totalRegistrationCertificatePriceInEuro && (
        <ResultField text={`${t('totalRegistrationCertificatePriceInEuro')} :`}>
          <p className="font-semibold">
            {item?.totalRegistrationCertificatePriceInEuro?.trim()}
          </p>
        </ResultField>
      )}
      {item?.issueDate && (
        <ResultField text={`${t('issueDate')} :`}>
          <p className="font-semibold">{item?.issueDate?.trim()}</p>
        </ResultField>
      )}
      {item?.issuingAuthority && (
        <ResultField text={`${t('issuingAuthority')} :`}>
          <p className="font-semibold">{item?.issuingAuthority?.trim()}</p>
        </ResultField>
      )}
    </>
  );
};
